import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b382233"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]

import { ref, withDefaults } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'pc-module-page-number-9',
  props: {
    isDetail: { type: Boolean, default: false },
    pageNo: { default: '01' }
  },
  setup(__props: any) {

const props = __props;

const svg = ref(`
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 131 61.394">
    <g id="yema9" transform="translate(-82 -378)">
      <rect id="矩形_2887" data-name="矩形 2887" width="131" height="13" transform="translate(82 426.394)" fill="var(--theme-color-1)"/>
      <text id="_01" data-name="01" transform="translate(82 412)" fill="var(--theme-color-1)" font-size="32" font-weight="600"><tspan x="0" y="0">${props.pageNo}</tspan></text>
    </g>
  </svg>
`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["svg-block", !_ctx.isDetail && 'isDetail']),
    innerHTML: svg.value
  }, null, 10, _hoisted_1))
}
}

})